export function Spinner({ size = 48 }: { size?: number }) {
  const borderWidth = size <= 14 ? 1.5 : size <= 20 ? 2 : 3;
  return (
    <div
      className="shrink-0"
      style={{
        width: size,
        height: size,
        border: `${borderWidth}px solid var(--t-border)`,
        borderTopColor: 'var(--t-text)',
        borderRadius: '50%',
        animation: 'nramp-spin 0.8s linear infinite',
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
    />
  );
}
